<template>
  <!--  -->
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center">
    <!--  -->
    <div class="bg-white w-fullrounded-lg shadow">
      <!--  -->
      <div class="h-20 py-3 flex items-center gap-2 md:gap-4 border-gray-200 p-6 mt-2">
        <!--  -->
        <div class="flex items-center gap-2 md:gap-4">
          <!--  -->
          <router-link :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-7 h-7 md:w-8 md:h-8" to="/products">
            <!--  -->
            <i class="material-icons mx-2">chevron_left</i>
            <!--  -->
          </router-link>
          <!--  -->

          <!--  -->
          <div v-if="!formData._id" class="text-xl md:text-2xl font-bold text-primary-500">
            {{ $t('new_product') }}
          </div>
          <!--  -->

          <!--  -->
          <div v-else class="text-xl md:text-2xl font-bold text-primary-500">
            {{ $t('edit_product') }}
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="">
        <!--  -->
        <div class="bg-white rounded-lg p-6 relative">
          <!--  -->
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <!--  -->

          <!--  -->
          <div class="grid lg:grid-cols-2 gap-6">
            <!--  -->
            <div
              class="border hover:border-primary-500 focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="name" class="bg-white text-gray-700 px-1">
                    <!--  -->
                    {{ $t('name') }}
                    <!--  -->
                    <span :class="$colors.required">*</span>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="name" autocomplete="false" tabindex="0" type="text" v-model="formData.name"
                  class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border hover:border-primary-500 focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="description" class="bg-white text-gray-700 px-1">
                    {{ $t('description') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="description" autocomplete="false" tabindex="0" type="description"
                  v-model="formData.description" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="code" class="bg-white text-gray-700 px-1">
                    {{ $t('code 0') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="code" autocomplete="false" tabindex="0" type="text" v-model="formData.code"
                  class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="code" class="bg-white text-gray-700 px-1">
                    {{ $t('code 1') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="code" autocomplete="false" tabindex="0" type="text" v-model="formData.code1"
                  class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="code" class="bg-white text-gray-700 px-1">
                    {{ $t('code 2') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="code" autocomplete="false" tabindex="0" type="text" v-model="formData.code2"
                  class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="code" class="bg-white text-gray-700 px-1">
                    {{ $t('Variant code') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="code" autocomplete="false" tabindex="0" type="text" v-model="formData.variant_code"
                  class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              class="border h-10 hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="verificationLink" class="bg-white text-gray-700 px-1">
                    {{ $t('product_page_link') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <input id="verificationLink" autocomplete="false" tabindex="0" type="text"
                  v-model="formData.verificationLink" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              v-if="formData._id && (currentUser.type == 'Admin' || currentUser.type == 'CEO' || currentUser.type == 'StockManager')"
              class="border hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolutes tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="outOfStock" class="bg-white text-gray-700 px-1">
                    {{ $t('out_of_stock') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="details w-full py-1">
                <!--  -->
                <template v-for="(item, key) in formData.details">
                  <!--  -->
                  <label v-if="item.warehouse.is_primary" :for="'toogle' + key"
                    class="cursor-pointer w-full flex justify-between py-1"
                    :class="item.warehouse.parent ? 'parent-warehouse' : ''">
                    <!--  -->

                    <div class="select-none mr-5">
                      <!--  -->
                      <img class="flag-img" :src="item.warehouse.flag" />
                      <!--  -->
                      {{ item.warehouse.name }}
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="relative">
                      <!--  -->
                      <input :id="'toogle' + key" type="checkbox" class="hidden" v-model="item.outOfStock" />
                      <!--  -->

                      <!--  -->
                      <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                      <!--  -->

                      <!--  -->
                      <div :class="'toggle__dot-' + key"
                        class="absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </label>
                  <!--  -->
                </template>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div v-if="sellersExist && currentUser.type != 'Seller'"
              class="border seller-select h-10 hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="seller" class="bg-white text-gray-700 px-1">
                    <!--  -->
                    {{ $t('seller') }}
                    <!--  -->
                    <span :class="$colors.required">*</span>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <p>
                <!--  -->
                <v-select label="company" @search="searchSellers($event, 'hh')" v-model="formData.seller"
                  :options="sellers">
                </v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <!--  -->
            <div
              class="border hover:border-primary-500  focus-within:border-primary-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <!--  -->
                <p>
                  <!--  -->
                  <label for="Picture" class="bg-white text-gray-700 px-1">
                    {{ $t('picture') }}
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="flex w-full mt-10 mb-10  items-center justify-center bg-grey-lighter">
                <!--  -->
                <label
                  class="w-64 flex flex-col items-center px-4 py-6 bg-white text-primary rounded-lg shadow-lg tracking-wide uppercase border border-primary cursor-pointer hover:bg-primary hover:text-white">
                  <!--  -->
                  <svg v-if="formData.picture == ''" class="w-8 h-8" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <!--  -->
                    <path
                      d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                    <!--  -->
                  </svg>
                  <!--  -->

                  <!--  -->
                  <img v-if="formData.picture != ''" :src="formData.picture" alt="" />
                  <!--  -->

                  <!--  -->
                  <span v-if="formData.picture == ''" class="mt-2 text-base leading-normal">
                    {{ $t('select_image') }}
                  </span>
                  <!--  -->

                  <!--  -->
                  <input type="file" @change="handleImage($event)" class="hidden" accept="image/*" />
                  <!--  -->
                </label>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="formData._id" class="flex mt-10 mb-5 items-center text-center">
            <!--  -->
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <!--  -->
            <label class="block font-medium text-base cursor-pointer text-primary-500 w-full"
              @click="setSelected('variantModel')">
              <!--  -->
              <div
                class="bg-indigo-100 mr-4 inline-block text-indigo-400 w-8 h-8 md:w-10 md:h-10 rounded-md  items-center justify-center font-bold text-lg font-display">
                <!--  -->
                <span class="align-middle"><i class="large font-bold material-icons align-bottom">settings</i></span>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <span class="font-medium text-base text-primary-700 dark:text-primary-800 align-middle">
                {{ 'Variantes Paramètres' }}
              </span>
              <!--  -->
            </label>
            <!--  -->

            <!--  -->
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="formData._id" class="flex mt-10 mb-5 items-center text-center">
            <!--  -->
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <!--  -->

            <!--  -->
            <label class="block font-medium text-base cursor-pointer text-primary-500  w-full"
              @click="setSelected('upsellModel')">
              <!--  -->
              <div
                class="bg-indigo-100 mr-4 inline-block text-indigo-400 w-8 h-8 md:w-10 md:h-10 rounded-md  items-center justify-center font-bold text-lg font-display">
                <!--  -->
                <span class="align-middle"><i class="large font-bold material-icons align-bottom">settings</i></span>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <span class="font-medium text-base text-primary-700 dark:text-primary-800 align-middle">
                {{ 'Upsell paramètres' }}
              </span>
              <!--  -->
            </label>
            <!--  -->

            <!--  -->
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="formData._id" class="flex mt-10 mb-5 items-center text-center">
            <!--  -->
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <!--  -->

            <!--  -->
            <label class="block font-medium text-base cursor-pointer text-primary-500  w-full"
              @click="setSelected('productsModel')">
              <!--  -->
              <div
                class="bg-indigo-100 mr-4 inline-block text-indigo-400 w-8 h-8 md:w-10 md:h-10 rounded-md  items-center justify-center font-bold text-lg font-display">
                <!--  -->
                <span class="align-middle"><i class="large font-bold material-icons align-bottom">settings</i></span>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <span class="font-medium text-base text-primary-700 dark:text-primary-800 align-middle">
                {{ 'Product Pack' }}
              </span>
              <!--  -->
            </label>
            <!--  -->

            <!--  -->
            <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="mt-6 pt-3 flex justify-center">
            <!--  -->
            <button
              class="text-base md:text-lg rounded focus:outline-none outline-none text-gray-100 py-1 md:py-2 px-2 md:px-3 w-fit md:w-1/6 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              @click="save">
              {{ $t('save') }}
            </button>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->

    <!--Modal Variant setting -->
    <vue-modal-2
      v-if="formData.details && formData.details[0] && formData.details[0].warehouse && formData.details[0].warehouse.name"
      name="variantModel" :headerOptions="{ title: 'Variantes paramètres' }" :noFooter="true" modalSize="lg"
      @on-close="close('variantModel')">
      <!--  -->
      <div class="bg-white rounded-lg">
        <!--  -->
        <div class="bg-white px-4 pt-0 pb-1 mb-20">
          <!--  -->
          <tabs :options="{ defaultTabHash: 'tab_' + idWharhouse.country }">
            <!--  -->
            <tab v-for="(vari, key) in formData.details.filter(item => item.warehouse && item.warehouse.is_primary)"
              :key="key" :id="'tab_' + vari.warehouse.country" :name="vari.warehouse.name">
              <!--  -->

              <!--  -->
              <div class="flex mt-5 mb-5 items-center text-center">
                <!--  -->
                <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
                <!--  -->

                <!--  -->
                <label class="block font-medium text-base cursor-pointer text-primary-500  w-full">
                  <!--  -->
                  <span
                    class="font-medium text-base text-primary-700 dark:text-primary-800 align-middle">Variantes</span>
                </label>
                <!--  -->

                <!--  -->
                <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="invoice-item-list">
                <!--  -->
                <div
                  class="border border-gray-600 hover:border-primary-500  focus-within:border-primary-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                  <!--  -->
                  <div class="-mt-4 absolutes tracking-wider px-1 capitalize text-xs">
                    <!--  -->
                    <p>
                      <!--  -->
                      <label for="outOfStock" class="bg-white text-gray-700 px-1">
                        {{ $t('Même produit avec différence de quantité ?') }}
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <p class="flex items-center justify-center w-full py-2">
                    <!--  -->
                    <label :for="'toogle' + key + 100" class="flex items-center cursor-pointer">
                      <!--  -->
                      <div class="relative">
                        <!--  -->
                        <input :id="'toogle' + key + 100" type="checkbox" class="hidden" v-model="vari.upsel" />
                        <!--  -->

                        <!--  -->
                        <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                        <!--  -->

                        <!--  -->
                        <div :class="'toggle__dot-' + key + 100"
                          class="absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <div class="ml-3 text-gray-700 capitalize">{{ $t(vari.upsel) }}</div>
                      <!--  -->
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <table class="table invoice-table mt-3 invoice-table-edit">
                  <!--  -->
                  <thead class="thead">
                    <!--  -->
                    <tr>
                      <!--  -->
                      <th class="invoice-detail-margin">&nbsp;</th>
                      <!--  -->

                      <!--  -->
                      <th class="invoice-detail-quantity bg-gray-50">ID variante</th>
                      <!--  -->

                      <!--  -->
                      <th class="invoice-detail-total bg-gray-50">Name </th>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </thead>
                  <!--  -->

                  <!--  -->
                  <tbody class="invoice-items">
                    <!--  -->
                    <tr class="item-row item-row-1 with-tax" v-for="(variant, index) in vari.variantes" :key="index"
                      :class="variant.code ? 'STOREINO' : ''">
                      <!--  -->
                      <td class="item-row-actions"
                        style="text-align: center !important;vertical-align: middle !important;">
                        <!--  -->
                        <div class="confirm-delete-button"><button @click="variantActions('remove', key, index)"
                            title="Remove Item" class="btn btn-remove">
                            <!--  -->
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
                              class="svg-inline--fa fa-times fa-w-11 " role="img" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 352 512">
                              <!--  -->
                              <path fill="currentColor"
                                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                              </path>
                              <!--  -->
                            </svg>
                            <!--  -->
                          </button>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td data-label="Id" class="item-row-quantity">
                        <!--  -->
                        <div v-if="variant.id" class="w-full rounded-md inline-flex border">
                          <!--  -->
                          <div
                            class="cursor-pointer flex items-center font-bold text-s  w-100px justify-center border border-gray-400 w-1/4 bg-gray-100">
                            <!--  -->
                            <svg @click="Copy(variant.id)" class="svg-inline--fa fa-plus fa-w-14 "
                              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                              <!--  -->
                              <path d="M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24 17v-21h21v2h-19v19h-2z" />
                              <!--  -->
                            </svg>
                            <!--  -->
                          </div>
                          <!--  -->

                          <!--  -->
                          <input disabled :ref="variant.id" v-model="variant.id"
                            class="w-full border border-gray-400  focus:outline-none  bg-white text-gray-700 focus:text-gray-600 p-2">
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td data-label="Quantity" class="item-row-quantity">
                        <!--  -->
                        <div class="w-full rounded-md inline-flex border">
                          <!--  -->
                          <div
                            class="flex items-center font-bold text-s  w-100px justify-center border border-gray-400 w-1/4 bg-gray-100">
                            <!--  -->
                            <img v-if="variant.picture" :src="variant.picture" style="width: 30px;">
                            <!--  -->

                            <!--  -->
                            <svg v-else class="svg-inline--fa fa-plus fa-w-14 " xmlns="http://www.w3.org/2000/svg"
                              width="24" height="24" viewBox="0 0 24 24">
                              <!--  -->
                              <path
                                d="M13 0h11v12h-3.55c-.933 0-1.356.575-1.356 1.109 0 .332.155.672.438.953.294.284.468.388.468.786 0 .47-.534 1.152-1.5 1.152s-1.5-.682-1.5-1.152c0-.397.174-.501.469-.785.282-.281.438-.621.438-.953 0-.534-.424-1.109-1.356-1.109h-3.551v-4.551c0-.535.137-.44.454-.109.245.263.616.659 1.394.659 1.039 0 2.152-1.004 2.152-2.5s-1.113-2.5-2.152-2.5c-.777 0-1.148.396-1.394.659-.317.333-.454.424-.454-.109v-3.55zm-8.45 12c.534 0 .441-.137.108-.454-.262-.245-.658-.616-.658-1.394 0-1.039 1.004-2.152 2.5-2.152s2.5 1.113 2.5 2.152c0 .777-.396 1.148-.658 1.394-.331.315-.427.454.108.454h3.55v-4.55c0-.932.575-1.357 1.109-1.357.332 0 .672.156.953.438.285.296.389.469.786.469.47 0 1.152-.534 1.152-1.5s-.682-1.5-1.152-1.5c-.396 0-.501.173-.785.469-.281.282-.621.438-.953.438-.535 0-1.11-.425-1.11-1.357v-3.55h-12v12h4.55zm7.45 8.45c0-.533-.137-.442-.454-.109-.245.263-.616.659-1.394.659-1.039 0-2.152-1.004-2.152-2.5s1.113-2.5 2.152-2.5c.777 0 1.148.396 1.394.659.317.331.454.425.454-.109v-3.55h-3.55c-.933 0-1.356-.575-1.356-1.109 0-.332.155-.672.438-.953.294-.284.468-.388.468-.786 0-.47-.534-1.152-1.5-1.152s-1.5.682-1.5 1.152c0 .397.174.501.469.785.282.281.438.621.438.953-.001.535-.425 1.11-1.357 1.11h-4.55v11h12v-3.55zm8.45-7.45c-.534 0-.441.137-.108.454.262.245.658.616.658 1.394 0 1.039-1.004 2.152-2.5 2.152s-2.5-1.113-2.5-2.152c0-.777.396-1.148.658-1.394.331-.315.427-.454-.108-.454h-3.55v3.55c0 .932-.575 1.357-1.109 1.357-.332 0-.672-.156-.953-.438-.285-.296-.389-.469-.786-.469-.47 0-1.152.534-1.152 1.5s.682 1.5 1.152 1.5c.396 0 .501-.173.785-.469.281-.282.621-.438.953-.438.534 0 1.109.425 1.109 1.357v3.55h11v-11h-3.549z" />
                              <!--  -->
                            </svg>
                            <!--  -->
                          </div>
                          <!--  -->

                          <!--  -->
                          <input type="text" v-model="variant.name"
                            class="w-full border border-gray-400 focus:outline-none  bg-white text-gray-700 focus:text-gray-600 p-2">
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->

                    <!--  -->
                    <tr class="item-row item-row-n">
                      <!--  -->
                      <td class="item-row-actions" colspan="3">
                        <!--  -->
                        <button id="invoice-item-add" @click="variantActions('add', key)" title="Add Item"
                          class="btn btn-prime animation-pulse">
                          <!--  -->
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus"
                            class="svg-inline--fa fa-plus fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512">
                            <!--  -->
                            <path fill="currentColor"
                              d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                            </path>
                            <!--  -->
                          </svg>
                          <!--  -->
                        </button>
                        <!--  -->
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </tbody>
                  <!--  -->
                </table>
                <!--  -->
              </div>
              <!--  -->
            </tab>
            <!--  -->
          </tabs>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="modal-footer px-5 border0-t text-right">
          <!--  -->
          <button @click="close('variantModel')" :class="loading ? 'noselect' : ''"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Fermer</button>
          <!--  -->

          <!--  -->
          <button @click="save" :class="loading ? 'noselect' : ''"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-green-600 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative">Enregistrer</button>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </vue-modal-2>
    <!--  -->

    <!--Modal Upsell setting -->
    <vue-modal-2
      v-if="formData.details && formData.details[0] && formData.details[0].warehouse && formData.details[0].warehouse.name"
      name="upsellModel" :headerOptions="{ title: 'Upsell paramètres' }" :noFooter="true" modalSize="lg"
      @on-close="close('upsellModel')">
      <!--  -->
      <div class="bg-white rounded-lg">
        <!--  -->

        <div class="bg-white px-4 pt-0 pb-1 mb-20">
          <!--  -->
          <tabs :options="{ defaultTabHash: 'tab_' + idWharhouse.country }">
            <!--  -->
            <tab v-for="(ups, key) in formData.details.filter(item => item.warehouse && item.warehouse.is_primary)"
              :key="key" :id="'tab_' + ups.warehouse.country" :name="ups.warehouse.name">
              <div class="flex mt-5 mb-5 items-center text-center">
                <!--  -->
                <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
                <!--  -->
                <!--  -->
                <label class="block font-medium text-base cursor-pointer text-orange-500 w-full">
                  <!--  -->
                  <span class="font-medium text-base text-orange-700 dark:text-orange-800 align-middle">Upsell
                    paramètres</span>
                </label>
                <!--  -->
                <!--  -->
                <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="invoice-item-list">
                <!--  -->
                <table class="table invoice-table  invoice-table-edit">
                  <!--  -->
                  <thead class="thead">
                    <!--  -->
                    <tr>
                      <!--  -->
                      <th class="invoice-detail-margin">&nbsp;</th>
                      <!--  -->
                      <th class="invoice-detail-quantity bg-gray-50">Quantity</th>
                      <!--  -->
                      <th class="invoice-detail-total bg-gray-50">Prix</th>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </thead>
                  <!--  -->

                  <!--  -->
                  <tbody class="invoice-items">
                    <!--  -->
                    <tr class="item-row item-row-1 with-tax" v-for="(upsel, index) in ups.upsells" :key="index">
                      <!--  -->
                      <td class="item-row-actions"
                        style="text-align: center !important; vertical-align: middle !important;">
                        <!--  -->
                        <div v-if="index === (ups.upsells.length - 1)" class="confirm-delete-button">
                          <!--  -->
                          <button @click="removeUpsell(key, index)" title="Remove Item" class="btn btn-remove">
                            <!--  -->
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
                              class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 352 512">
                              <!--  -->
                              <path fill="currentColor"
                                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                              </path>
                              <!--  -->
                            </svg>
                            <!--  -->
                          </button>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td data-label="Quantity" class="item-row-quantity">
                        <!--  -->
                        <div class="w-full rounded-md inline-flex border">
                          <!--  -->
                          <div
                            class="flex items-center font-bold text-s  w-100px justify-center border border-gray-400 w-1/4 bg-gray-100">
                            <!--  -->
                            <svg class="svg-inline--fa fa-plus fa-w-14 " xmlns="http://www.w3.org/2000/svg" width="24"
                              height="24" viewBox="0 0 24 24">
                              <!--  -->
                              <path
                                d="M13 0h11v12h-3.55c-.933 0-1.356.575-1.356 1.109 0 .332.155.672.438.953.294.284.468.388.468.786 0 .47-.534 1.152-1.5 1.152s-1.5-.682-1.5-1.152c0-.397.174-.501.469-.785.282-.281.438-.621.438-.953 0-.534-.424-1.109-1.356-1.109h-3.551v-4.551c0-.535.137-.44.454-.109.245.263.616.659 1.394.659 1.039 0 2.152-1.004 2.152-2.5s-1.113-2.5-2.152-2.5c-.777 0-1.148.396-1.394.659-.317.333-.454.424-.454-.109v-3.55zm-8.45 12c.534 0 .441-.137.108-.454-.262-.245-.658-.616-.658-1.394 0-1.039 1.004-2.152 2.5-2.152s2.5 1.113 2.5 2.152c0 .777-.396 1.148-.658 1.394-.331.315-.427.454.108.454h3.55v-4.55c0-.932.575-1.357 1.109-1.357.332 0 .672.156.953.438.285.296.389.469.786.469.47 0 1.152-.534 1.152-1.5s-.682-1.5-1.152-1.5c-.396 0-.501.173-.785.469-.281.282-.621.438-.953.438-.535 0-1.11-.425-1.11-1.357v-3.55h-12v12h4.55zm7.45 8.45c0-.533-.137-.442-.454-.109-.245.263-.616.659-1.394.659-1.039 0-2.152-1.004-2.152-2.5s1.113-2.5 2.152-2.5c.777 0 1.148.396 1.394.659.317.331.454.425.454-.109v-3.55h-3.55c-.933 0-1.356-.575-1.356-1.109 0-.332.155-.672.438-.953.294-.284.468-.388.468-.786 0-.47-.534-1.152-1.5-1.152s-1.5.682-1.5 1.152c0 .397.174.501.469.785.282.281.438.621.438.953-.001.535-.425 1.11-1.357 1.11h-4.55v11h12v-3.55zm8.45-7.45c-.534 0-.441.137-.108.454.262.245.658.616.658 1.394 0 1.039-1.004 2.152-2.5 2.152s-2.5-1.113-2.5-2.152c0-.777.396-1.148.658-1.394.331-.315.427-.454-.108-.454h-3.55v3.55c0 .932-.575 1.357-1.109 1.357-.332 0-.672-.156-.953-.438-.285-.296-.389-.469-.786-.469-.47 0-1.152.534-1.152 1.5s.682 1.5 1.152 1.5c.396 0 .501-.173.785-.469.281-.282.621-.438.953-.438.534 0 1.109.425 1.109 1.357v3.55h11v-11h-3.549z" />
                              <!--  -->
                            </svg>
                            <!--  -->
                          </div>
                          <!--  -->
                          <input type="number" disabled v-model="upsel.quantity" min="0"
                            class="w-full border border-gray-400  focus:outline-none  bg-white text-gray-700 focus:text-gray-600 p-2">
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td data-label="Amount" class="item-row-amount">
                        <!--  -->
                        <div class="w-full rounded-md inline-flex border">
                          <!--  -->
                          <div
                            class="flex items-center  font-bold text-s  w-100px justify-center border border-gray-400 w-1/4 bg-gray-100">
                            <!--  -->
                            <span v-if="ups.warehouse"> {{ ups.warehouse.currency }}</span>
                            <!--  -->
                          </div>
                          <!--  -->
                          <input type="number" v-model="upsel.price" min="0"
                            class="w-full focus:outline-none border border-gray-400  bg-white  text-gray-700 focus:text-gray-600 p-2">
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->

                    <!--  -->
                    <tr class="item-row item-row-n">
                      <!--  -->
                      <td class="item-row-actions" colspan="3"><button id="invoice-item-add" @click="addUpsell(key)"
                          title="Add Item" class="btn btn-prime animation-pulse">
                          <!--  -->
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus"
                            class="svg-inline--fa fa-plus fa-w-14 " role="img" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512">
                            <!--  -->
                            <path fill="currentColor"
                              d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                            </path>
                            <!--  -->
                          </svg>
                          <!--  -->
                        </button>
                        <!--  -->
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </tbody>
                  <!--  -->
                </table>
                <!--  -->
              </div>
              <!--  -->
            </tab>
            <!--  -->
          </tabs>
          <!--  -->
        </div>
        <!--  -->

        <div class="modal-footer px-5 border0-t text-right">
          <a href="#" @click="close('upsellModel')" :class="loading ? 'noselect' : ''"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Fermer</a>
          <a href="#" @click="save" :class="loading ? 'noselect' : ''"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-green-600 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative">Enregistrer</a>
        </div>

      </div>
    </vue-modal-2>
    <!--  -->

    <!-- Model Products setting -->
    <vue-modal-2
      v-if="formData.details && formData.details[0] && formData.details[0].warehouse && formData.details[0].warehouse.name"
      name="productsModel" :headerOptions="{ title: 'Product Pack' }" :noFooter="true" modalSize="lg"
      @on-close="close('productsModel')">
      <!--  -->
      <div class="bg-white rounded-lg">
        <!--  -->
        <div class="bg-white px-4 pt-0 pb-1 mb-20">
          <!--  -->
          <div class="w-full flex item justify-center">
            <!--  -->
            <div class="border border-black p-4 w-full flex flex-col gap-4 shadow-xs rounded-lg">
              <!--  -->
              <div class="flex items-center text-center">
                <!--  -->
                <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
                <!--  -->

                <!--  -->
                <label class="block font-medium text-base cursor-pointer text-orange-500 w-full">
                  <!--  -->
                  <span class="font-medium text-base text-orange-700 dark:text-orange-800 align-middle">
                    {{ 'Pack settings' }}
                  </span>
                  <!--  -->
                </label>
                <!--  -->

                <!--  -->
                <hr class="border border-gray-500 -gray-300 border-1 w-full rounded-md">
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="w-full flex flex-wrap gap-8 justify-between items-center">
                <!--  -->
                <div class="flex items-center gap-4">
                  <!--  -->
                  <span class="block rounded-full h-12 w-12 bg-gray-200">
                    <i class="material-icons p-3 text-primary-500">local_mall</i>
                  </span>
                  <!--  -->

                  <!--  -->
                  <span class="block text-base font-semibold text-gray-600">{{ $t('products') }}</span>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <button @click="OpenPopUp"
                  class="flex text-white max-w-sm rounded-md text-center bg-primary-600 py-2 px-4 items-center">
                  <!--  -->
                  <span class="text-sm font-normal">
                    {{ $t('select_product') }}
                  </span>
                  <!--  -->
                </button>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div
                class="border border-primary-500  focus-within:border-primary-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolutes tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="outOfStock" class="bg-white text-gray-700 px-1">
                      {{ $t('Active product pack') }}
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->

                <!--  -->
                <p class="flex items-center justify-center w-full py-2">
                  <!--  -->
                  <label for="toogle-pack" class="flex items-center cursor-pointer">
                    <!--  -->
                    <div class="relative">
                      <!--  -->
                      <input id="toogle-pack" type="checkbox" class="hidden" v-model="formData.isPack" />
                      <!--  -->

                      <!--  -->
                      <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                      <!--  -->

                      <!--  -->
                      <div
                        class="toggle__dot-pack text-sm absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0">
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <div class="ml-3 text-gray-700 capitalize">{{ $t(formData.isPack) }}</div>
                    <!--  -->
                  </label>
                  <!--  -->
                </p>
                <!--  -->
              </div>
              <!--  -->

              <!--  -->
              <div class="w-full overflow-x-auto">
                <!--  -->
                <table v-if="formData.packs && this.calculate.length > 0" class="min-w-full leading-normal">
                  <!--  -->
                  <thead>
                    <!--  -->
                    <tr>
                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('name') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('unit_price') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('quantity') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('total') }}
                      </th>
                      <!--  -->

                      <!--  -->
                      <th
                        class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium bg-indigo-100 text-gray-600 uppercase tracking-wider">
                        {{ $t('actions') }}
                      </th>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </thead>
                  <!--  -->

                  <!--  -->
                  <tbody v-for="(item, index) in formData.packs" :key="index">
                    <!--  -->
                    <tr>
                      <!--  -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <!--  -->
                        <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900 font-bold">
                          <!--  -->
                          {{ item.product.name }}
                          <!--  -->

                          <!--  -->
                          <p
                            v-if="(item.product.variantes && item.product.variantes.length > 0 && item.product.source) || (item.variante && item.variante.id)">
                            <!--  -->
                            <small>
                              Varinate: {{ item.variante ? item.variante.name : item.product.source.name }}
                            </small>
                            <!--  -->
                          </p>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <!--  -->
                        <div>
                          <!--  -->
                          <input @input="calculateQtePrice(index, 'total')" autocomplete="off" tabindex="0" min="0"
                            type="number" v-model.number="item.unitPrice"
                            class="border border-orange-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-lg overflow-hidden" />
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                        <!--  -->
                        <div class="flex md:space-x-2">
                          <!--  -->
                          <button :class="$colors.textPrimary"
                            class="bg-primary-600 rounded-md w-6 h-6 flex items-center focus:outline-none"
                            @click="addQuantity(index)">
                            <!--  -->
                            <span class="font-bold text-2xl text-white">
                              <!--  -->
                              <i class="material-icons mt-2">add</i>
                              <!--  -->
                            </span>
                            <!--  -->
                          </button>
                          <!--  -->

                          <!--  -->
                          <span :class="$colors.textPrimary"
                            class="text-gray-700 text-sm h-6 flex items-center focus:outline-none">
                            <!--  -->
                            <input class="focus:outline-none text-center w-6 max-w-none min-w-0" type="text"
                              v-model="item.quantity" @input="calculateQtePrice(index, calculate[index].type)" />
                            <!--  -->
                          </span>
                          <!--  -->

                          <!--  -->
                          <button :class="$colors.textPrimary" @click="removeQuantity(index)"
                            class="bg-primary-600 rounded-md w-6 h-6 text-white flex items-center focus:outline-none">
                            <!--  -->
                            <span class="font-bold text-2xl text-white mt-1">
                              <!--  -->
                              <i class="material-icons">remove</i>
                              <!--  -->
                            </span>
                            <!--  -->
                          </button>
                          <!--  -->
                        </div>
                        <!--  -->
                        <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class=" py-2 whitespace-no-wrap border-b border-gray-200 text-center w-24 max-w-none min-w-0">
                        <!--  -->
                        <div class="flex gap-4 md:gap-2 min-w-content items-center ">
                          <!--  -->
                          <input @input="calculateQtePrice(index, 'price')" autocomplete="off" min="0" type="number"
                            v-model.number="calculate[index].price"
                            class="border border-orange-600 py-2 text-xs px-2 outline-none block h-full w-full rounded-lg overflow-hidden" />
                          <!--  -->
                          <sup class="text-black">({{ currentCurrency }})</sup>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->

                      <!--  -->
                      <td class="py-4 whitespace-no-wrap border-b border-gray-200">
                        <!--  -->
                        <div class="flex justify-center">
                          <!--  -->
                          <button @click="removeProduct(item, index)" :class="$colors.actionTable"
                            class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1">
                            <!--  -->
                            <i class="material-icons mx-1">delete</i>
                            <!--  -->
                          </button>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </tbody>
                  <!--  -->

                  <!--  -->
                  <tbody>
                    <!--  -->
                    <tr>
                      <!--  -->
                      <td colspan="4" class="px-6 text-right py-2 whitespace-no-wrap border-gray-200">
                        <!--  -->
                        <div class="text-xs leading-5 capitalize px-2 rounded-full font-bold text-gray-900">
                          {{ $t('total_price') }}:
                          {{ TotalPrice() }}
                          <!--  -->
                          <sup class="text-black">({{ currentCurrency }})</sup>
                          <!--  -->
                        </div>
                        <!--  -->
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </tbody>
                  <!--  -->
                </table>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div class="modal-footer px-5 border0-t text-right">
          <!--  -->
          <a href="#" @click="close('productsModel')" :class="loading ? 'noselect' : ''"
            class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
            Fermer
          </a>
          <!--  -->

          <!--  -->
          <a href="#" @click="save" :class="loading ? 'noselect' : ''"
            class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-600 py-2 px-8 items-center focus:outline-none md:float-right loidingconfirm relative">
            Enregistrer
          </a>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </vue-modal-2>
    <!--  -->

    <!-- Product Modal -->
    <vue-modal-2 name="productModal" :headerOptions="{ title: $t('add_products') }" :noFooter="true" modalSize="lg"
      @on-close="closePopUp">
      <!--  -->
      <div class="flex flex-col w-full h-auto p-5 pt-0 mb-12">
        <!--  -->
        <div class="flex w-full h-auto justify-center items-center">
          <!--  -->
          <div class="flex mb-2 w-full h-auto py-2 justify-center items-center text-2xl font-bold">
            <!--  -->
            <span class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex">
              <!--  -->
              <input type="search" name="search" v-model="searchText" placeholder="Search"
                class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none" />
              <!--  -->
              <i class="material-icons text-primary-600 m-2 mr-5 text-lg w-4 h-4">search</i>
              <!--  -->
            </span>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div>
          <!--  -->
          <div v-if="products.length <= 0" class="py-2">
            <!--  -->
            <span class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base">
              <!--  -->
              <p class="font-semibold flex text-primary-600 whitespace-no-wrap">
                <!--  -->
                <span class=""> {{ $t('no_products_found') }}</span>
                <!--  -->
              </p>
              <!--  -->
            </span>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-for="(item, index) in resultSearchUsers" :key="index" :value="item._id"
            class="flex w-full space-x-12 h-auto py-1 px-8 rounded border border-gray-300 mb-2">
            <!--  -->
            <div>
              <!--  -->
              <input type="checkbox" v-model="item.check" :class="'product-' + index"
                class="form-checkbox checkallbbox mt-6 h-5 w-5 text-primary-600 border-primary-600"
                @change="addProductsToTemp(item, index)" />
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div>
              <!--  -->
              <img :alt="item.name"
                :src="item.picture || 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"
                class="h-16 w-16 rounded-md mx-auto" />
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div class="w-full">
              <!--  -->
              <h3 class="text-gray-80 mt-1">{{ item.name }}</h3>
              <!--  -->
              <p class="text-gray-600 text-xs">
                {{ exceptDes(item.description) }}
              </p>
              <!--  -->
              <p v-if="item.variantes && item.variantes.length > 0">
                <!--  -->
                <v-select label="name" placeholder="Sélectionnez variante ..." :disabled="item.check"
                  v-model="item.source" :options="item.variantes" @input="selectAutoVariant(item, index)"
                  class="border border-gray-500 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"></v-select>
                <!--  -->
              </p>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="modal-footer px-5 border0-t text-right">
        <!--  -->
        <button @click="closePopUp"
          class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
          {{ $t('cancel') }}
        </button>
        <!--  -->

        <!--  -->
        <button @click="ConfirmOperation"
          class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-primary-600 py-2 px-8 items-center focus:outline-none md:float-right">
          {{ $t('confirm') }}
        </button>
        <!--  -->
      </div>
      <!--  -->
    </vue-modal-2>
    <!--  -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: '',
        code: '',
        price: 0,
        description: '',
        quantity: {
          inStock: 0,
          total: 0,
        },
        details: [{ price: 0 }],
        verificationLink: '',
        outOfStock: false,
        picture: '',
        seller: '',
        prices: [{ price: 0, warehouse: null }],
        isPack: false,
        packs: [],
      },
      loading: false,
      fullPage: false,
      currentUser: {},
      sellers: [],
      categories: [],
      sellersExist: false,
      idWharhouse: null,
      currency: '',
      countryW: '',
      faq_selected: false,
      mess: "ook",
      products: [],
      calculate: [],
      searchText: '',
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      selectedProduct: [],
      numberItemRepeated: 0,
      currentCurrency: ''
    };
  },
  async mounted() {
    await this.getwharhouseId();
    await this.getCurrency();
    await this.getContryW();
    await this.getUser();
    this.dataToEdit();
    this.getCategories();
    if (this.currentUser.type != 'Seller') await this.getSellers();
    else this.formData.seller = this.currentUser._id;
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter(product => {
          var regex = new RegExp(this.searchText, 'i');

          if (regex.test(product.name)) return regex.test(product.name);
          else if (regex.test(product.code)) return regex.test(product.code);
          else if (regex.test(product.code1)) return regex.test(product.code1);
          else return regex.test(product.code2);
        });
      } else {
        return this.products;
      }
    },
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) {
      await this.getwharhouseId();
      await this.getCurrency();
      await this.getContryW();
      if (this.currentUser.type != 'Seller') await this.getSellers();
      else this.formData.seller = this.currentUser._id;
    },
  },
  methods: {
    async OpenPopUp() {
      if (this.formData.seller) {
        await this.getProducts({});
        if (this.products.length > 0) {
          this.$vm2.open('productModal');
        } else {
          if (this.currentUser.type != 'Seller')
            alert(this.$t('no_products_seller'), 'warning');
          else {
            alert(this.$t('no_product_added'), 'warning');
          }
        }
      }
    },
    closePopUp() {
      this.$vm2.close('productModal');
    },
    async getProducts() {
      if (this.formData.seller) {

        const filters = {
          seller: this.formData.seller._id,
          'details.warehouse': this.idWharhouse._id,
          limit: 1000,
        };

        const res = await this.$server.search('products', filters);

        if (res.content.results) {
          this.products = res.content.results.filter(
            product => product._id !== this.formData._id
          );

          this.paginate.total = res.content.total;
          this.paginate.lastpage = res.content.last_page;
          this.paginate.per_page = res.content.per_page;
          this.paginate.currentpage = res.content.current_page;

          for (let i in this.products) {
            this.products[i].seller = this.products[i].seller._id;
            this.products[i].source = null;

            const resProductW = this.getElementInArray(
              this.products[i].details.filter(function (obj) {
                return obj.warehouse;
              }),
              this.idWharhouse._id
            );

            if (resProductW && resProductW.price) {
              this.products[i].price = resProductW.price;
            }

            if (resProductW.variantes && resProductW.variantes.length > 0) {
              this.products[i].variantes = resProductW.variantes.map(el => ({ id: el.id, name: el.name, picture: el.picture }));
            }
          }
        } else this.products = [];
      } else {
        alert(this.$t('must_select_seller'), 'warning');
      }
    },
    getElementInArray(data, value) {
      var result = data.filter(function (o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null;
    },
    addProductsToTemp(data, id) {
      if (data.check) {
        if (data.variantes && data.variantes.length > 0 && !data.source) {
          this.$toast.warning('Svp sélectionner une variante');
          data.check = false;
          let column = document.querySelector('.product-' + id);
          column.checked = false;
          return false;
        }

        var detail = { product: data, unitPrice: 0, quantity: 1 };

        if (data.category) {
          if (data.category._id) {
            detail.category = data.category._id;
          }
        }

        let found = 0;
        for (let i = 0; i < this.formData.packs.length; i++) {
          if (this.formData.packs[i].product._id == data._id) {
            if ((!this.formData.packs[i].product.source && !this.formData.packs[i].variante) ||
              (this.formData.packs[i].product.source && this.formData.packs[i].product.source.id === data.source.id) ||
              (this.formData.packs[i].variante && this.formData.packs[i].variante.id === data.source.id)) {
              found = found + 1;
              this.numberItemRepeated = this.numberItemRepeated + 1;
            }
          }
        }

        if (found < 1) {
          this.selectedProduct.push(detail);
        }
      } else {
        let pos = this.selectedProduct.map(function (e) { return e.product._id; }).indexOf(data._id);
        this.selectedProduct.splice(pos, 1);
        this.$nextTick(() => { this.$forceUpdate(); });
      }
    },
    removeProduct(data, index) {
      this.$confirm(this.$t('confirm_delete_product')).then(async () => {
        const productIndex = this.formData.packs.findIndex(
          o => o.product._id === data.product._id,
        );

        if (productIndex !== -1) {
          this.formData.packs.splice(productIndex, 1);
          this.calculate.splice(productIndex, 1);
        }

        data.product.check = false;
        alert(this.$t('product_deleted'), 'success');
      });
    },
    exceptDes(text) {
      if (text && text.length > 60) text = text.substring(0, 60) + '...';
      return text;
    },
    selectAutoVariant(data, id) {
      data.check = true;
      let column = document.querySelector('.product-' + id);
      column.checked = true;
      this.addProductsToTemp(data, id);
    },
    ConfirmOperation() {
      for (let i = 0; i < this.selectedProduct.length; i++) {
        this.formData.packs.push(this.selectedProduct[i]);
        this.calculate.push({ price: 0, type: 'total' });
      }

      this.selectedProduct = [];

      if (this.numberItemRepeated > 0) {
        alert(this.$t('product_already_added'), 'success');
      }

      this.numberItemRepeated = 0;
      this.$vm2.close('productModal');
    },
    addQuantity(index) {
      const item = this.formData.packs[index];
      item.quantity++;
      this.calculateQtePrice(index, this.calculate[index].type);
    },
    removeQuantity(index) {
      const item = this.formData.packs[index];
      if (item.quantity >= 1) {
        item.quantity--;
        this.calculateQtePrice(index, this.calculate[index].type);
      }
    },
    calculateQtePrice(index, type) {
      const item = this.formData.packs[index];
      if (type === 'total') {
        this.calculate[index].type = 'total';
        this.calculate[index].price = (item.unitPrice * item.quantity).toFixed(0);
      } else if (type === 'price' && item.quantity > 0) {
        this.calculate[index].type = 'price';
        item.unitPrice = (this.calculate[index].price / item.quantity)
      }
    },
    TotalPrice() {
      let Total = 0;
      for (const element of this.formData.packs) {
        Total += element.unitPrice * element.quantity;
      }
      this.formData.totalPrice = Total.toFixed(0);
      return Total.toFixed(0);
    },
    setSelected(modal) {
      this.$vm2.open(modal);
    },
    close(modal) {
      this.$vm2.close(modal);
    },
    removeUpsell(indexPr, indexUpsl) {
      this.formData.details[indexPr].upsells.splice(indexUpsl, 1);
    },
    addUpsell(index) {
      const upsells = this.formData.details[index].upsells;
      const nextQuantity = upsells.length > 0 ? Math.max(...upsells.map(upsell => upsell.quantity)) + 1 : 2;

      upsells.push({ quantity: nextQuantity, price: 0 });
    },
    Copy(text) {
      const vm = this
      this.$copyText(text).then(function (e) {
        vm.$toast.success('Copied');
      }, function (e) {
        vm.$toast.warning('Can not copy');
      })
    },
    variantActions(action, indexPr, indexUpsl) {
      if (action === 'remove') this.formData.details[indexPr].variantes.splice(indexUpsl, 1);
      else {
        this.formData.details[indexPr].variantes.push({ id: 'VA' + Date.now().toString(36).toUpperCase(), name: "" })
      }
    },
    checkingData() {
      let dataRes = null;
      for (const i in this.formData.details) {
        for (const j in this.formData.details[i].variantes) {
          if (!this.formData.details[i].variantes[j].name) {
            dataRes = "Nom variante obligatoire";
            return dataRes;
          }
        }
        if (this.formData.details[i].variantes.map(el => el.name.toUpperCase()).some((e, i, arr) => arr.indexOf(e) !== i)) {
          dataRes = "Duplicate nom du variante !!!";
          return dataRes;
        }
      }
      return dataRes;
    },
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.idWharhouse = res;
      });
    },
    async getContryW() {
      const warhouse = await this.$server.get('warehouses', {
        id: this.idWharhouse._id,
      });
      this.countryW = warhouse.content.country;
      this.currentCurrency = warhouse.content.currency;
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then(res => {
        this.currency = res;
      });
    },
    searchSellers: _.debounce(async function (search) {
      const filter = {
        type: 'Seller',
        limit: this.limit,
        countries: await this.warhouseSelected,
        name: search,
      };
      const res = await this.$server.find('users', filter);
      if (res && res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    }, 500),
    handleImage(e) {
      const selectImage = e.target.files[0];
      if (selectImage) this.createBase64Image(selectImage);
    },
    createBase64Image(fileObjet) {
      const reader = new FileReader();
      reader.readAsDataURL(fileObjet);
      reader.onload = () => {
        this.formData.picture = reader.result;
      };
    },
    async save() {
      if (this.formData._id) {
        if (!this.checkSize()) {
          this.$toast.warning(`la taille de image doit pas dépasser 500 ko !! `);
          return false;
        }

        if (this.checkingData()) {
          this.$toast.warning(this.checkingData());
          return false;
        }

        this.loading = true;
        const data = await this.$server.update('products', this.formData);
        this.loading = false;

        if (data && data._id) {
          this.$toast.success(this.$t('product_updated'));
        } else {
          if (data.content) this.$toast.warning(data.content,);
          else this.$toast.warning(`There was a problem updating the product, please try again later`);
        }
      } else {
        if (this.checkData() && this.checkSize()) {
          this.loading = true;
          this.formData.details[0].warehouse = this.idWharhouse._id;

          const data = await this.$server.create('products', this.formData);
          this.loading = false;

          if (data && data._id) {
            this.formData = {
              name: '',
              code: '',
              price: 0,
              description: '',
              quantity: {
                inStock: 0,
                total: 0,
              },
              details: [{ price: 0 }],
              verificationLink: '',
              outOfStock: false,
              picture: '',
              seller: '',
            };

            if (this.currentUser.type == 'Seller') {
              this.formData.seller = this.currentUser._id;
            }

            alert(this.$t('product_created'), 'success');
          } else {
            if (data.content) alert(data.content, 'error');

            else
              alert(
                'There was a problem creating the product, please try again later',
                'error',
              );
          }
        } else {
          if (!this.checkData()) alert(this.$t('all_required_field'), 'warning');
          if (!this.checkSize()) alert(`la taille de image doit pas dépasser 500 ko !! `, 'warning');
        }
      }
    },
    checkData() {
      if (this.formData.name) return true;
      else return false;
    },
    niceBytes(x) {
      const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let l = 0,
        n = parseInt(x, 10) || 0;
      while (n >= 1024 && ++l) {
        n = n / 1024;
      }
      return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];
    },
    checkSize() {
      let base64Length = this.formData.picture.length - (this.formData.picture.indexOf(',') + 1);
      let padding =
        this.formData.picture.charAt(this.formData.picture.length - 2) === '=' ? 2
          : this.formData.picture.charAt(this.formData.picture.length - 1) === '=' ? 1 : 0;

      let fileSize = base64Length * 0.75 - padding;
      let sizeImage = this.niceBytes(fileSize);

      let typeSize = sizeImage.split(' ')[1];
      if (typeSize === 'bytes' || typeSize === 'KB') {
        if (sizeImage.split(' ')[0] <= 500) return true;
        else return false;
      } else return false;
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        this.loading = true;
        const editData = await this.$server.get('products', {
          id: this.$route.params.id,
        });

        this.formData = editData.content;

        this.calculate = this.formData.packs.map(detail => ({
          price: (detail.unitPrice * detail.quantity).toFixed(0),
          type: 'total',
        }));

        this.formData.details.forEach(detail => {
          if (!detail.variantes) detail.variantes = [];
          if (!detail.upsells) detail.upsells = [];
        });

        this.formData.details = this.sortByAttribute(this.formData.details, 'country', '_id',);

        this.loading = false;
      }
    },
    sortByAttribute(array, ...attrs) {
      let predicates = attrs.map(pred => {
        let descending = pred.charAt(0) === '-' ? -1 : 1;
        pred = pred.replace(/^-/, '');
        return {
          getter: o => o.warehouse[pred],
          descend: descending,
        };
      });

      return array
        .map(item => {
          return {
            src: item,
            compareValues: predicates.map(predicate => predicate.getter(item)),
          };
        })

        .sort((o1, o2) => {
          let i = -1,
            result = 0;
          while (++i < predicates.length) {
            if (o1.compareValues[i] < o2.compareValues[i]) result = -1;
            if (o1.compareValues[i] > o2.compareValues[i]) result = 1;
            if ((result *= predicates[i].descend)) break;
          }
          return result;
        })
        .map(item => item.src);
    },
    async getCategories() {
      const res = await this.$server.search('categories');
      if (res.content.results) this.categories = res.content.results;
      else this.categories = [];
    },
    async getSellers() {
      const filter = {
        type: 'Seller',
        countries: await this.warhouseSelected,
      };

      const res = await this.$server.search('users', filter);

      if (res.content.results) {
        this.sellers = res.content.results;
        this.sellersExist = true;
      } else this.sellers = [];
    },
    async getUser() {
      const res = await this.$server.me('users');
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
  },
};
</script>

<style scoped>
.vs__dropdown-toggle {
  border: none;
}

.details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 300px;
}

.parent-warehouse {
  border-left: 1px solid #000;
  padding-left: 20px;
  position: relative;
  margin-left: 18px;
  line-height: 24px;
}
</style>
